module.exports = __webpack_public_path__ + "img/action.d473aac6.svg";